<template>
  <div class="footer">
    <div class="footer-content">
      <div class="footer-left">
        <div class="footer-column">
          <div class="column-title">
            {{ $t("navbar.products") }}
          </div>
          <ul>
            <li v-for="(item, itemIndex) in productList" :key="itemIndex">
              <a
                href="#"
                @click.prevent="handleNavigate('/product/' + item.id)"
                >{{
                  $i18n.locale === "en"
                    ? item.productNameEn || item.productName
                    : item.productName
                }}</a
              >
            </li>
          </ul>
        </div>
        <div
          v-for="(column, index) in navColumns"
          :key="index"
          class="footer-column"
        >
          <div
            class="column-title"
            @click.prevent="handleNavigate(column.path)"
          >
            {{ column.title }}
          </div>
          <ul>
            <li v-for="(item, itemIndex) in column.items" :key="itemIndex">
              <a href="#" @click.prevent="handleNavigate(item.path)">{{
                item.name
              }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer-right">
        <div v-for="(info, index) in contactInfo" :key="index" class="address-item">
          <h4>{{ info.contactName || $t("footer.addressTitle") }}</h4>
          <p>
            {{ $i18n.locale === "en" ? info.addressEn || info.address : info.address }}
          </p>
          <p v-if="info.phone">
            {{ info.phone }}
          </p>
          <p v-if="info.email">{{ info.email }}</p>
          <div class="city-name">{{ info.contactNameEn }}</div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <div class="footer-logo-section">
          <div class="footer-logo">
            <SvgImage height="35" width="150" />
          </div>
          <div class="footer-qrcode">
            <img :src="qrcode" alt="WeChat QR Code" width="128" height="128" />
          </div>
        </div>
        <div class="footer-copyright">
          <p>{{ $t("footer.copyright") }}</p>
          <p>{{ $t("footer.licenseNumbers") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgImage from "@/assets/icon.svg?component";
import qrcode from "@/assets/qrcode.png";
export default {
  name: "Footer",
  components: {
    SvgImage,
  },
  inject: ["contentMap", "currentLanguage", "contactInfo"],
  props: {
    // 是否显示地址
    showAddress: {
      type: Boolean,
      default: true,
    },
    productList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      qrcode,
    };
  },
  computed: {
    navColumns() {
      return [
        {
          title: this.$t("navbar.technology"),
          items: [
            {
              name: this.contentMap["technology-feature-1-title"]?.[
                this.currentLanguage
              ],
              path: "/technology",
            },
            {
              name: this.contentMap["technology-feature-2-title"]?.[
                this.currentLanguage
              ],
              path: "/technology",
            },
            {
              name: this.contentMap["technology-feature-3-title"]?.[
                this.currentLanguage
              ],
              path: "/technology",
            },
            {
              name: this.contentMap["technology-feature-4-title"]?.[
                this.currentLanguage
              ],
              path: "/technology",
            },
          ],
        },
        {
          title: this.$t("navbar.about"),
          items: [
            { name: this.$t("about.company"), path: "/profile#profile" },
            { name: this.$t("about.team"), path: "/profile#team" },
            { name: this.$t("about.cases"), path: "/cooperationCases" }
          ],
        },
        {
          title: this.$t("navbar.news"),
          items: [{ name: this.$t("news.company"), path: "/news" }],
        },
        {
          title: this.$t("navbar.contact"),
          items: [
            { name: this.$t("navbar.contact"), path: "/cooperation" },
            { name: this.$t("navbar.join"), path: "/join" }
          ],
        },
      ];
    },
  },
  methods: {
    // 处理导航点击
    handleNavigate(path) {
      this.$router.push(path);
      // 滚动到顶部
      const targetElement = document.querySelector(".navbar");
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
  },
};
</script>

<style scoped>
.footer {
  background-color: #222;
  color: white;
  /* padding: 40px 0 20px; */
  font-size: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.footer-content {
  display: flex;
  width: 100vw;
  justify-content: space-between;
  /* max-width: 1200px; */
  /* margin: 0 auto; */
  /* padding: 0 20px; */
}

.footer-left {
  display: flex;
  gap: 60px;
  padding: 48px;
}

.column-title {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 20px;
  cursor: default;
  font-weight: 500;
}
/* .column-title:hover {
  color: rgba(255, 255, 255, 0.8);
} */
.footer-column h4 {
  font-size: 16px;
  margin-bottom: 15px;
  font-weight: 600;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-column li {
  margin-bottom: 10px;
}

.footer-column a {
  color: rgba(255, 255, 255);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-column a:hover {
  color: white;
}

.footer-right {
  display: flex;
  flex-direction: column;
  width: 400px;
  /* gap: 40px; */
}

.address-item {
  position: relative;
  /* width: 200px; */
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  padding: 48px;
}
.address-item + .address-item {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.address-item h4 {
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: 600;
}

.address-item p {
  margin: 5px 0;
  opacity: 0.8;
}

.city-name {
  /* position: absolute;
  bottom: 0;
  right: 0; */
  font-size: 48px;
  font-weight: 100;
  opacity: 0.1;
  z-index: 0;
}

.footer-bottom {
  /* margin-top: 40px; */
  padding: 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* max-width: 1200px; */
  margin: 0 auto;
  padding: 0 20px;
}

.footer-logo-section {
  display: flex;
  align-items: center;
  gap: 40px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-qrcode {
  display: flex;
  align-items: center;
}

.footer-qrcode img {
  height: 128px;
  width: 128px;
  object-fit: contain;
}

.logo-image {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.logo-text {
  font-size: 20px;
  font-weight: bold;
}

.footer-copyright p {
  margin: 5px 0;
  font-size: 12px;
  opacity: 0.8;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .footer-content {
    flex-direction: column;
    gap: 30px;
  }

  .footer-left {
    flex-wrap: wrap;
    gap: 40px;
  }

  .footer-right {
    justify-content: space-between;
  }
}

@media (max-width: 768px) {
  .footer-left {
    flex-direction: column;
    gap: 20px;
  }

  .footer-right {
    flex-direction: column;
    gap: 20px;
    width: 100%;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }

  .address-item {
    width: 100%;
  }

  .footer-bottom-content {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }

  .footer-logo-section {
    flex-direction: column;
    gap: 20px;
  }

  .footer-qrcode img {
    height: 100px;
    width: 100px;
  }
}
</style>
